module.exports = __webpack_public_path__ + "static/media/appcenter-recoveryEmailSent.5e602a22.svg";